import { Box } from '@mui/material';
import Footer from '../../components/Footer/Footer.component';
import Header from '../../components/Header/Header.component';
import { ContainerLimit } from './Erro-style';
import React from 'react';

export default function Erro() {
  return (
    <Box>
      <Header></Header>
      <ContainerLimit>Página não econtrada</ContainerLimit>
      <Footer></Footer>
    </Box>
  );
}
